<template>
  <div
    class="flex flex-row items-center gap-3"
    :data-id="`subscription-${addon}-display`"
    :data-addon-switch="addon"
    :data-has="hasAddon ? '1' : '0'"
  >
    <BooleanCheck hint="" :value="!!hasAddon" />
    <FormDropDown v-if="hasAddon" :data-id="`edit-product-${addon}`" size="xs">
      <template #button-content>
        <span class="p-0" data-id="plan-product-open"
          ><Icon class="text-xs" icon="cog"
        /></span>
      </template>
      <FormDropDownItem v-if="!!hasAddon && manageTo" button @click="onManage">
        <span :data-id="`manage-${addon}-product`">{{ 'Manage' }}</span>
      </FormDropDownItem>
      <FormDropDownItem v-if="!!hasAddon" button @click="onDisable">
        <span :data-id="`disable-${addon}-product`">{{ 'Disable' }}</span>
      </FormDropDownItem>
    </FormDropDown>
    <UpgradeButtonInert
      v-else
      type="button"
      size="sm"
      :loading="false"
      @click="onEnable"
    >
      <span :data-id="`enable-${addon}-product`">{{ 'Enable' }}</span>
    </UpgradeButtonInert>
  </div>
</template>
<script setup lang="ts">
import Icon from './form/Icon.vue';
import FormDropDown from './form/FormDropDown.vue';
import BooleanCheck from './BooleanCheck.vue';
import FormDropDownItem from './form/FormDropDownItem.vue';

import UpgradeButtonInert from './pricing/UpgradeButtonInert.vue';
import { navigateTo } from 'nuxt/app';

const props = withDefaults(
  defineProps<{
    hasAddon: boolean;
    addon: string;
    manageTo?: string;
  }>(),
  {
    manageTo: undefined,
  },
);
const emit = defineEmits<{ (e: 'enable'): void; (e: 'disable'): void }>();

const onManage = async () => await navigateTo(props.manageTo ?? '/upgrade');
const onEnable = () => emit('enable');
const onDisable = () => emit('disable');
</script>
